import React from 'react';
import VerifyPropertyForm from './VerifyPropertyForm';

export default function UploadDocumentToProperty() {
  return <VerifyPropertyForm />;
}
